<template>
	<footer>
		<div class="row footer-bottom">
			<div class="col-twelve">
				<div class="copyright">
					<span v-html="copyright"></span>
					<span>Site Template by <a href="https://www.colorlib.com/">Colorlib</a></span>
				</div>

				<div class="go-top">
					<a class="smoothscroll" title="Back to Top" href="#top"><i class="icon-arrow-up" aria-hidden="true"></i></a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	// import params
	import {params as SiteParams} from '../../params';

	// export
	export default {
		name: 'SectionFooter',
		data: function() {
			return {
				yearCurrent: (new Date()).getFullYear(),
				yearSite: SiteParams['year']
			}
		},
		computed: {
			copyright: function () {
				// detect if site year matches the current year
				if (this.yearCurrent === this.yearSite) {
					return '&copy <a href="http://punkass.me">GonzoPunkass</a> ' + this.yearSite;
				} else {
					return '&copy <a href="http://punkass.me">GonzoPunkass</a> ' + this.yearSite + '&ndash;' + this.yearCurrent;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/sections/Footer.vue